import { Question } from './question.interface';
import { QuestionId } from './question.model';
import { Category } from './category.model';
import { SimpleQuestion } from './simple-question.model';

export class ComplexQuestion implements Question {
  constructor(
    private id: QuestionId = null,
    public type: string = null,
    public order: number = 0,
    public comment: string = null,
    public simpleQuestion: SimpleQuestion[] = [],
    public categoryVisible: boolean = false
  ) { }

  public getId(): QuestionId {
    return this.id;
  }

  public setOrder(order: number): void {
    this.order = order;
  }

}



// WEBPACK FOOTER //
// /dist/src/app/question/complex-question.model.ts